// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBPdeoGbJIcAPy60sEZokz8lBdau4PDq9I',
    authDomain: 'fir-workshop-34e73.firebaseapp.com',
    databaseURL: 'https://fir-workshop-34e73.firebaseio.com',
    projectId: 'fir-workshop-34e73',
    storageBucket: 'fir-workshop-34e73.appspot.com',
    messagingSenderId: '534289104042'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
